// extracted by mini-css-extract-plugin
export default {"container":"success-screen_container__d5r+f","title":"success-screen_title__ZcKcY","description":"success-screen_description__GSIDW"};